import { useCallback, useState } from "react";
import usePosApi from "@apis/usePosApi";

/**
 * 取得POS訂單抵用劵折扣資料
 */
const usePosCampaignDiscount = () => {
	const { postPosItemsCampaignApi } = usePosApi();

	// 折扣結果
	const [campaignResult, setCampaignResult] = useState(null);

	/**
	 * 依照目前參數取得折扣結果
	 * @param {Object} params - 包含 memberID, products, campaignID 等參數
	 */
	const fetchCampaignDiscount = useCallback(
		async params => {
			if (!params?.campaignID) {
				setCampaignResult(null);
				return null;
			}
			try {
				const resp = await postPosItemsCampaignApi(params);
				setCampaignResult(resp);
				return resp;
			} catch (error) {
				// 捕捉後端錯誤，避免呼叫端畫面壞掉
				setCampaignResult(null);
				console.error("fetchCampaignDiscount error:", error);
			}
		},
		// eslint-disable-next-line
		[postPosItemsCampaignApi],
	);

	/**
	 * 清除折扣結果
	 */
	const clearCampaignResult = useCallback(() => {
		setCampaignResult(null);
	}, []);

	return { campaignResult, fetchCampaignDiscount, clearCampaignResult };
};

export default usePosCampaignDiscount;
